export default __webpack_public_path__ + "static/media/grade-24px.88a7b568.svg";